import styled from "@emotion/styled";
import { timelineColors } from "../../theme/config";

export const ContentWrapper = styled.div`
  padding: 15px 20px;
  display: block;
  width: 375px;
  border-right: 1px solid ${timelineColors.border};
  background-color: #fff;
`;

export const SearchWrapper = styled.div`
  position: relative;
  margin-top: 20px;
  input {
    width: 100%;
    font-size: 12px;
    padding: 12.5px 0px;
  }
  i {
    font-size: 14px !important;
    top: 15px;
  }
  button {
    top: 7.5px;
  }
`;

export const ListWrapper = styled.div`
  overflow-y: scroll;
  margin-top: 12.5px;
  height: calc(100% - 101px);
`;

export const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  h2 {
    padding-bottom: 0px !important;
    margin-bottom: 0px !important;
  }
`;
